// sliders.js
/**
 * This module initializes all the sliders present on the website.
 * Using Swiper library: http://idangero.us/swiper/
 */

// Swiper imports
import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

// Get all slider instances in the DOM
const sliders = document.querySelectorAll('[data-slideshow]');

/**
 * Initialize all sliders
 */
function initSliders() {
    if (!sliders.length) return;

    sliders.forEach(slider => {
        new Swiper(slider, {
            direction: 'horizontal',
            loop: false,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
        });
    });
}

// Initialize on module load
if (sliders.length) {
    initSliders();
}